
<div class="l-section1">

  <div class="l-header">

    <img routerLink = '/' src="assets/images/logo3.png" alt="">
  
  </div>
  
  <div class="l-hero">

    <h1>The Future of Learning Starts with Sehyog Academy</h1>

    <h4>Personalized Learning for Every Student from Struggling to Advanced</h4>

    <p>We tackle the growing gap between curriculum coverage and exam performance <br> with structured support, AI-powered learning, and expert guidance</p>


    <div class="l-btn-hero">

      <button class="org" (click)="showDemoForm = true">Book a Free Demo</button>

      <button class="blc" routerLink = '/contact-us'>Contact Us</button>

    </div>


    <div class="l-mid-section">
      

      <h4>Powered by intelligent technology, the platform adapts in real-time to your child’s strengths and areas of growth, offering personalized lessons that evolve with their progress. While AI guides the learning path, expert educators deliver engaging mini-lessons to keep students motivated and on track.</h4>


    </div>


  
  
  
  </div>

</div>


<!-- about section -->

<div class="about-section">
  <h1 class="about-title">Who We Are?</h1>

  <div class="about-desc">
    <span class="about-highlight">Sehyog Academy LLP</span> is transforming education by integrating AI-driven personalized learning with live instruction. Our platform offers tailored learning paths, real-time analytics, and expert teaching, ensuring students receive the support they need to excel academically.
  </div>
  
</div>


<!-- learning with fun -->

<div class="page-container">
  <h1 class="main-title">Learning With Fun</h1>

  <div class="browser-window">
    <div class="window-bar">
      <span class="window-dot red"></span>
      <span class="window-dot yellow"></span>
      <span class="window-dot green"></span>
    </div>
    <div class="content-section">
      <h2 class="highlight-title">
        Sehyog Academy Makes Studying Fun for Students
      </h2>
      <p class="subtext">
        Say goodbye to study struggles with our interactive online learning experience! Is your child facing challenges in Math or other subjects? At Sehyog Academy, we turn learning into an engaging journey with fun, personalized lessons and games designed just for them.
      </p>
      <p class="subtext">
        Every child is different — and their learning should be too. Our program offers <a href="#" class="orange-link">customized instruction</a> that adapts to each learner’s pace and style, helping students build confidence and master concepts while making it easier for educators to support every child’s unique needs.
      </p>
      <p class="bold-text">
        Let’s make learning joyful and effective — together.
      </p>
      <button class="cta-btn" (click)="showDemoForm = true">Book a Free Demo</button>
    </div>
    <img class="classroom-img" src="assets/images/l-w-fun.jpg" />
  </div>
</div>


<!-- programs we offer -->


<div class="programs-section">
  <h1 class="programs-title">Programs We Offer</h1>
  <div class="programs-card">
    <ul class="programs-list">
      <li> <strong>Comprehensive Courses:</strong> Structured programs for Year 3 to Year 13, covering KS2/11plus, KS3, GCSE, and A-Level</li>
      <li> <strong>Mock Exams:</strong> Real-time, curriculum-aligned mock tests to assess readiness and identify areas for improvement.</li>
      <li> <strong>Crash Courses:</strong> Intensive sessions focusing on key topics and exam strategies to boost performance.</li>
      <li> <strong>Technical Training:</strong> Skill development and certification programs to enhance employability and practical knowledge.</li>
    </ul>
    <div class="programs-img-wrap">
      <img 
        src="assets/images/fsce1.jpg"
        alt="Student writing in classroom"
        class="programs-img"
      />
    </div>
  </div>
</div>


<!-- our model -->

<section class="ai-insight-section">
  <p class="apple-gradient">
    Transforming Learning with AI Insight
  </p>
  <div class="ai-insight-lead">
    <b>At Sehyog Academy, we don’t just teach — we adapt, personalize, and empower.</b>
  </div>
  <div class="ai-insight-desc">
    Our AI-first education platform redefines academic support by putting the learner at the center of a smart, scalable, and globally accessible ecosystem
  </div>

  <div class="ai-cards">
    <div class="ai-card">
      <div class="ai-card-left">
        <div class="ai-card-title">Learning That Learns You</div>
        <div class="ai-card-text">
          Forget one-size-fits-all. Our AI engine continuously learns about each student—their pace, struggles, strengths—and adapts lessons in real-time. The result? Smarter effort. Better outcomes. Zero guesswork.
        </div>
      </div>
      <div class="ai-card-image">
        <img src="assets/images/ai1.jpg" alt="AI Brain">
      </div>
    </div>
    <div class="ai-card">
      <div class="ai-card-left">
        <div class="ai-card-title">Live Meets Digital, Seamlessly</div>
        <div class="ai-card-text">
          Our hybrid model combines the structure of live classroom interaction with the freedom of online learning. It’s flexible, engaging, and tailored for modern students who need both guidance and autonomy.
        </div>
      </div>
      <div class="ai-card-image">
        <img src="assets/images/ai2.jpg">
      </div>
    </div>
    <div class="ai-card">
      <div class="ai-card-left">
        <div class="ai-card-title">Progress You Can See (And Act On)</div>
        <div class="ai-card-text">
          Students, parents, and educators get instant performance dashboards—no more waiting for test results. With continuous feedback and early alerts, support becomes proactive, not reactive.
        </div>
      </div>
      <div class="ai-card-image">
        <img src="assets/images/ai3.jpg" alt="Progress dashboard">
      </div>
    </div>
    <div class="ai-card">
      <div class="ai-card-left">
        <div class="ai-card-title">Designed for the World, Powered by India</div>
        <div class="ai-card-text">
          Built to scale across borders, Sehyog connects international learners with India's top educators. High-quality, affordable education that meets global curriculum standards—no passport required.
        </div>
      </div>
      <div class="ai-card-image">
        <img src="assets/images/ai4.jpg" alt="Globe">
      </div>
    </div>
    <div class="ai-card">
      <div class="ai-card-left">
        <div class="ai-card-title">Practice That Feels Like the Real Exam</div>
        <div class="ai-card-text">
          Our AI doesn’t just teach—it assesses. With non-plagiarized, curriculum-aligned practice questions, students are equipped with unlimited, exam-style practice that actually prepares them for the real thing.
        </div>
      </div>
      <div class="ai-card-image">
        <img src="assets/images/sat-bg.png" alt="Practice exam">
      </div>
    </div>
  </div>
</section>

<!-- no stress setup -->

<div class="no-stress-section">
  <div class="no-stress-bg"></div>
  <div class="no-stress-content">
    <h2 class="no-stress-title">No-Stress Setup</h2>
    <div class="no-stress-badge">
      <span class="badge-main">Made for Students,</span>
      <span class="badge-bold">Easy for Parents</span>
    </div>
    <div class="no-stress-try">Try it free</div>
    <button class="no-stress-btn" (click)="showDemoForm = true">Book a Free Demo</button>
    <div class="no-stress-footer">
      Experience how Sehyog Academy can boost your child’s skills and confidence in Math and beyond.
    </div>
  </div>
</div>


<!-- LOVE SECTION  -->

<div class="love-section">
  <h2 class="love-title">
    Why <span class="love-orange">Students &amp; Parents</span>
  </h2>
  <div class="love-heart">❤️LOVE❤️</div>
  <div class="love-btn-wrap">
    <button class="love-btn">SEHYOG</button>
  </div>
  <div class="love-features-row">
    <div class="love-feature-card">
      <img src="assets/images/l1-ico.jpg" alt="Simple illustration" class="feature-img" />
      <div class="feature-heading">Personalized Learning at Scale</div>
      <div class="feature-desc">
        Our AI-powered platform adapts to each student’s pace, learning style, and performance—shifting the focus from rote memorization to deep conceptual understanding. Real-time insights empower educators and engage parents for better outcomes.
      </div>
    </div>
    <div class="love-feature-card">
      <img src="assets/images/l2-ico.jpg" alt="Accessible illustration" class="feature-img" />
      <div class="feature-heading">Innovation-Driven Education</div>
      <div class="feature-desc">
        We combine live classes, adaptive content, intelligent dashboards, and instant feedback loops to create a hybrid model that enhances teaching and learning. Our system supports early interventions and continuous academic growth.
      </div>
    </div>
    <div class="love-feature-card">
      <img src="assets/images/l3-ico.jpg" alt="Effective illustration" class="feature-img" />
      <div class="feature-heading">Scalable & Global by Design</div>
      <div class="feature-desc">
        Built for minimal infrastructure and maximum reach, our tech-first model is expanding across geographies. We aim to uplift learners globally.
      </div>
    </div>
  </div>
</div>


<!-- mission section -->

<div class="mission-section">
  <h2>Uniqueness of the Solution</h2>
  <div class="mission-card">
    
    <div class="mission-row">
      <!-- Card 1 -->
      <div class="mission-col">
        <div class="mission-icon">
          <i class="fa fa-universal-access"></i>
        </div>
        <div class="mission-title">
          <strong>1. Accessible,<br>Global-Standard Education</strong>
        </div>
        <div class="mission-text">
          Sehyog Academy breaks geographical and economic barriers by delivering affordable, high-quality academic support to students in India and abroad. Our fully online, tech-enabled platform ensures global accessibility without compromising educational standards.
        </div>
      </div>
      <!-- Card 2 -->
      <div class="mission-col">
        <div class="mission-icon">
          <i class="fa fa-desktop"></i>
        </div>
        <div class="mission-title">
          <strong>2. Hybrid Learning<br>with Real-Time Insights</strong>
        </div>
        <div class="mission-text">
          We combine the flexibility of online content with the structure of live, community-based classes. Interactive sessions, instant feedback, and continuous progress tracking empower students, teachers, and parents to stay aligned and act early when support is needed.
        </div>
      </div>
      <!-- Card 3 -->
      <div class="mission-col">
        <div class="mission-icon">
          <i class="fa fa-globe"></i>
        </div>
        <div class="mission-title">
          <strong>3. Scalable, Global-Ready Ecosystem</strong>
        </div>
        <div class="mission-text">
          Our model is designed for global expansion with minimal infrastructure. By leveraging India’s skilled educator base, Sehyog delivers high-quality, affordable tutoring aligned to international curricula—bridging global education gaps at scale.
        </div>
      </div>
    </div>
  </div>
</div>



<!-- Global footprint -->


<div class="global-footprint-section">
  <h2 class="global-title">Our Global Footprint</h2>
  <div class="global-row">
    <div class="global-card global-card-large"
         style="background-image: url('https://images.unsplash.com/photo-1486299267070-83823f5448dd?q=80&w=2942&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D');">
      <span class="global-card-text">Serving in<br/>United Kingdom</span>
    </div>
    <div class="global-card global-card-small"
         style="background-image: url('https://images.unsplash.com/photo-1600450575743-43793ba079d3?q=80&w=2946&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D');">
      <span class="global-card-text">Now Expanding in<br/>United Arab Emirates</span>
    </div>
  </div>
  <div class="global-divider">Upcoming In</div>
  <div class="global-row">
    <div class="global-card global-card-small"
         style="background-image: url('https://images.unsplash.com/photo-1477587458883-47145ed94245?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D');">
      <span class="global-card-text">India</span>
    </div>
    <div class="global-card global-card-small"
         style="background-image: url('https://images.unsplash.com/photo-1600664356348-10686526af4f?q=80&w=2950&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D');">
      <span class="global-card-text">Singapore</span>
    </div>
  </div>
</div>



<!-- FOOTER SECTION -->

<footer class="site-footer">
  <div class="footer-top">
    <img src="assets/images/logo3.png" alt="Sehyog Academy Logo" class="footer-logo" />
  </div>

  <div class="footer-contact-row">
    <span class="footer-label">Contact Us:</span>
    <span class="footer-contact">+44 (0)20 39808244</span>
    <span class="footer-contact"><a href="mailto:someone@sehyoug.co.uk">support&#64;sehyog.co.uk</a></span>
  </div>
  <div class="footer-bottom">
    ©SEHYOG ACADEMY
  </div>
</footer>


<!-- Book Demo Button -->

<!-- Demo Request Modal -->
<!-- Book Demo Button -->

<!-- Modal Overlay -->
<div class="demo-modal-overlay" *ngIf="showDemoForm" (click)="closeDemoModal()">
  <div class="flip-modal demo-modal" [class.flipped]="formSubmitted" (click)="$event.stopPropagation()">
    <!-- FRONT (Form) -->
    <div class="flip-face flip-front">
      <div class="demo-modal-header">
        <h2>Book a Free Demo</h2>
        <button class="close-btn" type="button" (click)="closeDemoModal()">&times;</button>
      </div>
      <form #f="ngForm" (ngSubmit)="submitDemoForm(f)" autocomplete="off" class="demo-form">
        <div class="form-row">
          <label for="studentName">Student Name</label>
          <input id="studentName" name="studentName" ngModel required />
        </div>
        <div class="form-row">
          <label for="parentName">Parent Name</label>
          <input id="parentName" name="parentName" ngModel required />
        </div>
        <div class="form-row-2">
          <div>
            <label for="mobile">Mobile</label>
            <input id="mobile" name="mobile" ngModel required maxlength="15" />
          </div>
          <div>
            <label for="email">Email</label>
            <input id="email" type="email" name="email" ngModel required />
          </div>
        </div>
        <div class="form-row">
          <label for="address">Address</label>
          <input id="address" name="address" ngModel required />
        </div>
        <div class="form-row">
          <label for="desc">About the Student</label>
          <textarea id="desc" name="desc" rows="3" ngModel></textarea>
        </div>
        <button
          class="org demo-submit-btn"
          type="submit"
          [disabled]="!f.valid"
        >
          Submit Request
        </button>
      </form>
    </div>
    <!-- BACK (Thank you) -->
    <div class="flip-face flip-back">
      <button class="close-btn thanks-close-btn" type="button" (click)="closeDemoModal()">&times;</button>
      <div class="thank-you-content">
        <div class="thank-you-icon">
          <svg width="84" height="84" viewBox="0 0 84 84">
            <circle cx="42" cy="42" r="40" stroke="#1ec871" stroke-width="4" fill="#eafff3"/>
            <polyline points="26,45 39,58 59,34" fill="none" stroke="#1ec871" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="thank-you-title">Thank you!</div>
        <div class="thank-you-msg">We have received your request.<br>We will contact you soon.</div>
      </div>
    </div>
  </div>
</div>